import PropTypes from 'prop-types';
import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import ChannelSelectToggleButton from './ChannelSelectToggleButton';
import ChannelSelectFilterInput from './ChannelSelectFilterInput';
import ChannelSelectOptionGroup from './ChannelSelectOptionGroup';
import ChannelSelectNoOptions from './ChannelSelectNoOptions';
import ChannelSelectIncludeForm from './ChannelSelectIncludeForm';
import { useChannelSelectorLogic } from './logic';

import './index.scss';

const ChannelSelector = (props) => {
  const {
    filterText,
    setFilterText,
    isSelectorHidden,
    isSelectorOpen,
    toggleSelectorOpen,
    newConversationChannels,
    replyViaChannels,
    selectChannel,
    selectedChannel,
    hasNoPickableChannels,
    includeFormProp,
  } = useChannelSelectorLogic(props);

  const maximiseMinimiseButton = props.maximiseButton;

  if (isSelectorHidden) {
    return (
      <div className="ChannelSelector">
        <div className="row">
          <div className="col"></div>
          <div className="col"></div>
          {maximiseMinimiseButton}
        </div>
      </div>
    );
  }

  return (
    <div className="ChannelSelector">
      <div className="row">
        <div className="col">
          <Dropdown
            drop="up"
            show={isSelectorOpen}
            onToggle={toggleSelectorOpen}
          >
            <ChannelSelectToggleButton
              selectedChannel={selectedChannel}
              isOpen={isSelectorOpen}
            />
            <Dropdown.Menu role="menu" className="gecko-dropdown-menu">
              <ChannelSelectFilterInput
                filterText={filterText}
                onChange={setFilterText}
                isSelectorOpen={isSelectorOpen}
              />
              <div className="ChannelSelector__optionGroups">
                {hasNoPickableChannels ? <ChannelSelectNoOptions /> : null}
                <ChannelSelectOptionGroup
                  groupName="Start new conversation via"
                  channels={newConversationChannels}
                  onSelect={selectChannel}
                />
                <ChannelSelectOptionGroup
                  groupName="Reply to conversation via"
                  channels={replyViaChannels}
                  onSelect={selectChannel}
                />
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col">
          <ChannelSelectIncludeForm
            isFormResponse={includeFormProp.currentChannelIsFormResponse}
            onIncludeFormResponse={includeFormProp.onIncludeFormResponse}
          />
        </div>
        {maximiseMinimiseButton}
      </div>
    </div>
  );
};

ChannelSelector.propTypes = {
  channels: PropTypes.array,
  hidden: PropTypes.bool,
  noteChannelId: PropTypes.number,
  noteMode: PropTypes.object,
  selectedChannel: PropTypes.object,
  onChannelSelected: PropTypes.func,
  isPickingInitialChannel: PropTypes.bool,
  includeFormProp: PropTypes.object,
};

export default ChannelSelector;
